// extracted by mini-css-extract-plugin
module.exports = {"root":"Search_root__SMLeG","btn":"Search_btn__2E36R"};